/* Svensk katalog for locale-journal-recovery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'journalRecovery.title': 'Bokföringen är tillfälligt otillgänglig',
  'journalRecovery.description': 'Journalen kunde inte kontrolleras. Bokföringssidor och ändringar är spärrade tills kontrollen lyckas. Du kan kontakta support eller byta företag i menyn.',
  'journalRecovery.reference': 'Företag: {businessId} · Räkenskapsår: {year}',
  'journalRecovery.retry': 'Försök igen',
  'journalRecovery.retrying': 'Kontrollerar …',
  'journalRecovery.support': 'Kontakta support',
  'journalRecovery.signOut': 'Logga ut',
  'journalRecovery.writeBlocked': 'Journalunderlaget är otillgängligt. Försök igen innan du ändrar bokföringen.',
});
